import Footer from "./Footer";
import FooterCopyRights from "./FooterCopyRights";
import FooterStaticPages from "./FooterStaticPages";

export { Footer, FooterStaticPages, FooterCopyRights };
export default Footer;
